import type { UserRole } from '@/features/courses/useCourse';

export interface ProcessedQuestionText {
  instructorComments: string[];
  studentText: string;
}

const INSTRUCTOR_COMMENT_PATTERN = /\/\*([\s\S]*?)\*\//g;

export function processQuestionText(
  text: string,
  role: UserRole,
): ProcessedQuestionText {
  const instructorComments: string[] = [];
  const studentText = text.replace(
    INSTRUCTOR_COMMENT_PATTERN,
    (_match, comment: string) => {
      const normalizedComment = comment.trim();

      if (normalizedComment.length > 0) {
        instructorComments.push(normalizedComment);
      }

      return '';
    },
  );

  return {
    instructorComments: role === 'student' ? [] : instructorComments,
    studentText,
  };
}
